import { render } from "./EventTablaOtrosPagos.vue?vue&type=template&id=c52e23fe&scoped=true"
import script from "./EventTablaOtrosPagos.vue?vue&type=script&lang=js"
export * from "./EventTablaOtrosPagos.vue?vue&type=script&lang=js"

import "./EventTablaOtrosPagos.vue?vue&type=style&index=0&id=c52e23fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52e23fe"]])

export default __exports__